import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calculator } from "lucide-react";
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { CalculosRevisionais } from "@/components/calculos/CalculosRevisionais";
import { AtualizacaoValores } from "@/components/calculos/AtualizacaoValores";
import { CalculosTrabalhistas } from "@/components/calculos/CalculosTrabalhistas";
import { CalculosFGTS } from "@/components/calculos/CalculosFGTS";
import { PensaoAlimenticia } from "@/components/calculos/PensaoAlimenticia";
import { CalculosAluguel } from "@/components/calculos/CalculosAluguel";
import { Superendividamento } from "@/components/calculos/Superendividamento";
import { CalculosPASEP } from "@/components/calculos/CalculosPASEP";
import { DosimetriaPena } from "@/components/calculos/DosimetriaPena";
import { ProgressaoRegime } from "@/components/calculos/ProgressaoRegime";
import { CalculosRMC } from "@/components/calculos/CalculosRMC";
import { CalculosINSS } from "@/components/calculos/CalculosINSS";
import { CalculosDivorcio } from "@/components/calculos/CalculosDivorcio";
import IndicesEconomicosCard from "@/components/calculos/IndicesEconomicosCard";
import CalculoHistoryList from "@/components/calculos/CalculoHistoryList";
import { CalculoType } from "@/hooks/useCalculoHistory";


const Calculos = () => {
  const [tab, setTab] = useState<CalculoType>("revisionais");

  return (
    <SidebarInset>
      <div className="flex h-full flex-col">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <div className="flex items-center gap-2">
            <Calculator className="h-6 w-6" />
            <h1 className="text-xl font-semibold">Cálculos Jurídicos e Financeiros</h1>
          </div>
        </header>
        
        <div className="flex-1 overflow-auto p-4">
          <div className="max-w-2xl mx-auto">
            <div data-tour="indices-card">
              <IndicesEconomicosCard />
            </div>
            <Tabs value={tab} onValueChange={(v) => setTab(v as CalculoType)} className="w-full" data-tour="calc-form">
            <TabsList className="grid w-full grid-cols-6 mb-2">
              <TabsTrigger value="revisionais">Revisionais</TabsTrigger>
              <TabsTrigger value="atualizacao">Atualização</TabsTrigger>
              <TabsTrigger value="trabalhistas">Trabalhistas</TabsTrigger>
              <TabsTrigger value="fgts">FGTS</TabsTrigger>
              <TabsTrigger value="pensao">Pensão</TabsTrigger>
              <TabsTrigger value="aluguel">Aluguel</TabsTrigger>
            </TabsList>
            
            <TabsList className="grid w-full grid-cols-7 mb-6">
              <TabsTrigger value="superendividamento">Super End.</TabsTrigger>
              <TabsTrigger value="pasep">PASEP</TabsTrigger>
              <TabsTrigger value="dosimetria">Dosimetria</TabsTrigger>
              <TabsTrigger value="progressao">Progressão</TabsTrigger>
              <TabsTrigger value="rmc">RMC</TabsTrigger>
              <TabsTrigger value="inss">INSS</TabsTrigger>
              <TabsTrigger value="divorcio">Divórcio</TabsTrigger>
            </TabsList>
            
            <TabsContent value="revisionais">
              <CalculosRevisionais />
            </TabsContent>
            
            <TabsContent value="atualizacao">
              <AtualizacaoValores />
            </TabsContent>
            
            <TabsContent value="trabalhistas">
              <CalculosTrabalhistas />
            </TabsContent>
            
            <TabsContent value="fgts">
              <CalculosFGTS />
            </TabsContent>
            
            <TabsContent value="pensao">
              <PensaoAlimenticia />
            </TabsContent>
            
            <TabsContent value="aluguel">
              <CalculosAluguel />
            </TabsContent>
            
            <TabsContent value="superendividamento">
              <Superendividamento />
            </TabsContent>
            
            <TabsContent value="pasep">
              <CalculosPASEP />
            </TabsContent>
            
            <TabsContent value="dosimetria">
              <DosimetriaPena />
            </TabsContent>
            
            <TabsContent value="progressao">
              <ProgressaoRegime />
            </TabsContent>
            
            <TabsContent value="rmc">
              <CalculosRMC />
            </TabsContent>
            
            <TabsContent value="inss">
              <CalculosINSS />
            </TabsContent>
            
            <TabsContent value="divorcio">
              <CalculosDivorcio />
            </TabsContent>
            </Tabs>

            <CalculoHistoryList onEdit={(type) => setTab(type)} />
          </div>
        </div>
      </div>
    </SidebarInset>
  );
};

export default Calculos;